import { Component, Inject } from '@angular/core';
import { VexConfigService } from '@vex/config/vex-config.service';
import {
  MatSlideToggleChange,
  MatSlideToggleModule
} from '@angular/material/slide-toggle';
import { map } from 'rxjs/operators';
import {
  AsyncPipe,
  NgClass,
  NgFor,
  NgIf,
  UpperCasePipe
} from '@angular/common';
import { Observable } from 'rxjs';
import {
  VexColorScheme,
  VexThemeProvider
} from '@vex/config/vex-config.interface';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { VEX_ACCENTS, VEX_THEMES } from '@vex/config/config.token';

@Component({
  selector: 'vex-config-panel',
  templateUrl: './config-panel.component.html',
  styleUrls: ['./config-panel.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatIconModule,
    MatRippleModule,
    NgFor,
    NgClass,
    MatSlideToggleModule,
    AsyncPipe,
    UpperCasePipe
    ]
})
export class ConfigPanelComponent {
  isRTL$: Observable<boolean> = this.configService.select(
    (config) => config.direction === 'rtl'
  );

  colorScheme$: Observable<VexColorScheme> = this.configService.select(
    (config) => config.style.colorScheme
  );

  isSelectedTheme$: Observable<(theme: string) => boolean> = this.configService
    .select((config) => config.style.themeClassName)
    .pipe(map((themeClassName) => (theme: string) => themeClassName === theme));
  isSelectedAccent$: Observable<(accent: string) => boolean> = this.configService
    .select((config) => config.style.accentClassName)
    .pipe(
      map((accentClassName) => (accent: string) => accentClassName === accent)
    );

  constructor(
    private readonly configService: VexConfigService,
    @Inject(VEX_THEMES) public readonly themes: VexThemeProvider[],
    @Inject(VEX_ACCENTS) public readonly accents: VexThemeProvider[]
  ) { }

  selectTheme(theme: VexThemeProvider): void {
    this.configService.updateConfig({
      style: {
        themeClassName: theme.className
      }
    });
  }

  selectAccent(accent: VexThemeProvider): void {
    this.configService.updateConfig({
      style: {
        accentClassName: accent.className
      }
    });
  }

  enableDarkMode(): void {
    this.configService.updateConfig({
      style: {
        colorScheme: VexColorScheme.DARK
      }
    });
  }

  disableDarkMode(): void {
    this.configService.updateConfig({
      style: {
        colorScheme: VexColorScheme.LIGHT
      }
    });
  }

  layoutRTLChange(change: MatSlideToggleChange): void {
    this.configService.updateConfig({
      direction: change.checked ? 'rtl' : 'ltr'
    });
  }

  isDark(colorScheme: VexColorScheme): boolean {
    return colorScheme === VexColorScheme.DARK;
  }
}
